<template>
  <div class="primary">
    <v-card 
      :height="height?height:'50'"
      :color="background?background:'primary'"
      :tile="true">
      <v-layout row wrap fill-height="" class="pa-0 ma-0"> 
        <v-card v-for="(item, index) in items.sort(not.dynamicSort('votes'))" 
          :key="index"
          tile="" dark hover=""
          :color="item?item.party_color:''"
          :style="'width:'+item.votes+'%;'">
          <v-layout 
            column justify-center="" 
            align-center="" fill-height=""
            class="pa-2">
            <div v-if="item.votes>5" class="font-weight-bold">{{item.party_short_name}}</div>
            <div v-else>..</div>
            <div v-if="item.votes>5">{{(item.votes).toFixed(1)}}% </div>
            <div v-else>..</div>
          </v-layout>
        </v-card> 
      </v-layout> 
    </v-card>
  </div>
</template>

<script>
export default {
  props:["not","height","background","items"],
  data: () => ({
     
  }),
  computed: {
    phoneSize(){ 
      let  width = this.not.vs.width 
      if(width<1000){
        return true
      }else{
        return false
      }
    },
    us(){
      return this.not.us
    },
    links(){
      let path = this.$route.path
      return path.split("/")
    }
  },
  methods: {
    navOpen(){
      this.$emit("navOpen")
    },
    clicked(){},
     getLink(item){
      let index = item.index
      let name = item.name
      let path = this.$route.path
      let id = this.$route.path

      if (!index) {
        return "/"
      }
      if (index===0) {
        return "/"
      }else {
        let link = path.split(name)  
        return link[0]+name
      }
    }
  },
};
</script>
